import { Buffer3384y49aj0pxr as Buffer } from './Buffer.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var RealBufferedSinkClass;
function RealBufferedSink() {
  if (RealBufferedSinkClass === VOID) {
    class $ {
      constructor(sink) {
        this.o3x_1 = sink;
        this.p3x_1 = false;
        this.q3x_1 = new (Buffer())();
      }
      i3s(source, byteCount) {
        // Inline function 'okio.internal.commonWrite' call
        // Inline function 'kotlin.check' call
        if (!!this.p3x_1) {
          var message = 'closed';
          throw IllegalStateException().o(toString(message));
        }
        this.q3x_1.i3s(source, byteCount);
        this.r3x();
        return Unit_instance;
      }
      s3w(byteString) {
        // Inline function 'okio.internal.commonWrite' call
        // Inline function 'kotlin.check' call
        if (!!this.p3x_1) {
          var message = 'closed';
          throw IllegalStateException().o(toString(message));
        }
        this.q3x_1.s3w(byteString);
        return this.r3x();
      }
      u3w(string) {
        // Inline function 'okio.internal.commonWriteUtf8' call
        // Inline function 'kotlin.check' call
        if (!!this.p3x_1) {
          var message = 'closed';
          throw IllegalStateException().o(toString(message));
        }
        this.q3x_1.u3w(string);
        return this.r3x();
      }
      v3w(string, beginIndex, endIndex) {
        // Inline function 'okio.internal.commonWriteUtf8' call
        // Inline function 'kotlin.check' call
        if (!!this.p3x_1) {
          var message = 'closed';
          throw IllegalStateException().o(toString(message));
        }
        this.q3x_1.v3w(string, beginIndex, endIndex);
        return this.r3x();
      }
      w3w(b) {
        // Inline function 'okio.internal.commonWriteByte' call
        // Inline function 'kotlin.check' call
        if (!!this.p3x_1) {
          var message = 'closed';
          throw IllegalStateException().o(toString(message));
        }
        this.q3x_1.w3w(b);
        return this.r3x();
      }
      r3x() {
        // Inline function 'okio.internal.commonEmitCompleteSegments' call
        // Inline function 'kotlin.check' call
        if (!!this.p3x_1) {
          var message = 'closed';
          throw IllegalStateException().o(toString(message));
        }
        var byteCount = this.q3x_1.d3w();
        if (byteCount > 0n) {
          this.o3x_1.i3s(this.q3x_1, byteCount);
        }
        return this;
      }
      oc() {
        // Inline function 'okio.internal.commonFlush' call
        // Inline function 'kotlin.check' call
        if (!!this.p3x_1) {
          var message = 'closed';
          throw IllegalStateException().o(toString(message));
        }
        if (this.q3x_1.k3s_1 > 0n) {
          this.o3x_1.i3s(this.q3x_1, this.q3x_1.k3s_1);
        }
        this.o3x_1.oc();
        return Unit_instance;
      }
      l6() {
        var tmp$ret$0;
        $l$block: {
          // Inline function 'okio.internal.commonClose' call
          if (this.p3x_1) {
            tmp$ret$0 = Unit_instance;
            break $l$block;
          }
          var thrown = null;
          try {
            if (this.q3x_1.k3s_1 > 0n) {
              this.o3x_1.i3s(this.q3x_1, this.q3x_1.k3s_1);
            }
          } catch ($p) {
            if ($p instanceof Error) {
              var e = $p;
              thrown = e;
            } else {
              throw $p;
            }
          }
          try {
            this.o3x_1.l6();
          } catch ($p_0) {
            if ($p_0 instanceof Error) {
              var e_0 = $p_0;
              if (thrown == null)
                thrown = e_0;
            } else {
              throw $p_0;
            }
          }
          this.p3x_1 = true;
          if (!(thrown == null))
            throw thrown;
          tmp$ret$0 = Unit_instance;
        }
        return tmp$ret$0;
      }
      toString() {
        // Inline function 'okio.internal.commonToString' call
        return 'buffer(' + toString(this.o3x_1) + ')';
      }
    }
    initMetadataForClass($, 'RealBufferedSink');
    RealBufferedSinkClass = $;
  }
  return RealBufferedSinkClass;
}
//region block: exports
export {
  RealBufferedSink as RealBufferedSinkipqv3pv5gqfq,
};
//endregion

//# sourceMappingURL=RealBufferedSink.mjs.map
